"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const siteSettings_1 = require("../Redux/Actions/siteSettings");
const useDisableScroll = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    return (isDisabled) => dispatch((0, siteSettings_1.setIsScrollActive)(isDisabled));
};
exports.default = useDisableScroll;
